export const refreshTokenKey = 'ledgerportal_refresh-token'
export const accessTokenKey = 'ledgerportal_access-token'
